<template>
    <div class="send-discuss">
        <div class="discuss-list">
            <p v-show="isSearchResult">你还没有发表任何评论</p>
            <vue-loading v-show="isshowloading" style="height: calc(100% - 20px);border:none;top:0;left:0"></vue-loading>
            <div class="list-item" v-for="(item, index) in discussDataList" :key="index" v-show="!isSearchResult && !isshowloading">
                <div class="item-left">
                    <img :src="item.my_avatar">
                    <!-- <img :src="userAvatar"> -->
                </div>
                <div class="item-right">
                    <div class="item-name">{{item.nickname}}</div>
                    <p>{{item.mine}}</p>
                    <div class="item-mix">
                        <span>{{item.ctime}}</span>
                        <span class="item-like">赞同({{item.likes}})</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="pagination-heart">
            <vue-pagination
                class="square-page"
                :page-size="pageSize"
                :total="total"
                @current-change="goPage">
            </vue-pagination>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'send-discuss',
        mounted () {
            this.updateList()
        },
        data () {
            return {
                currentPage: 1,
                pageSize: 10,
                isshowloading: false,
                isSearchResult: false
            }
        },
        computed: {
            sendDiscussData () {
                return this.$store.getters['myStrategy/sendDiscussData']
            },
            discussDataList () {
                return this.sendDiscussData.list
            },
            total () {
                return this.sendDiscussData.total
            }
        },
        methods: {
            goPage (page) {
                this.currentPage = page
            },
            updateList () {
                var self = this
                this.isshowloading = true
                this.$store.dispatch('myStrategy/requestSendDiscuss', {
                    page: this.currentPage,
                    pagesize: this.pageSize
                }).then((result) => {
                    self.isshowloading = false
                    if (self.discussDataList.length === 0) {
                        self.isSearchResult = true
                    } else {
                        self.isSearchResult = false
                    }
                }).catch((error) => {
                    self.isshowloading = false
                    self.$tip({
                        message: error ? error.message : '网络异常',
                        duration: 2000,
                        type: 'error'
                    })
                })
            }
        },
        watch: {
            currentPage () {
                this.updateList()
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    @import '../../scss/mystrategy/send-discuss.scss';
</style>



// WEBPACK FOOTER //
// src/components/mystrategy/send-discuss.vue